// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.property-card {
  margin: 16px;
}

table {
  width: 100%;
}

.mat-column-name {
  width: 20%;
}

.mat-column-type {
  width: 20%;
}

.mat-column-description {
  width: 60%;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFydGljbGUtcHJvcGVydGllcy5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNJLFlBQUE7QUFDSjs7QUFFRTtFQUNFLFdBQUE7QUFDSjs7QUFFRTtFQUNFLFVBQUE7QUFDSjs7QUFFRTtFQUNFLFVBQUE7QUFDSjs7QUFFRTtFQUNFLFVBQUE7QUFDSiIsImZpbGUiOiJhcnRpY2xlLXByb3BlcnRpZXMuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIucHJvcGVydHktY2FyZCB7XG4gICAgbWFyZ2luOiAxNnB4O1xuICB9XG4gIFxuICB0YWJsZSB7XG4gICAgd2lkdGg6IDEwMCU7XG4gIH1cbiAgXG4gIC5tYXQtY29sdW1uLW5hbWUge1xuICAgIHdpZHRoOiAyMCU7XG4gIH1cbiAgXG4gIC5tYXQtY29sdW1uLXR5cGUge1xuICAgIHdpZHRoOiAyMCU7XG4gIH1cbiAgXG4gIC5tYXQtY29sdW1uLWRlc2NyaXB0aW9uIHtcbiAgICB3aWR0aDogNjAlO1xuICB9Il19 */`, "",{"version":3,"sources":["webpack://./src/app/components/site-management/article-properties/article-properties.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;;AAEE;EACE,WAAA;AACJ;;AAEE;EACE,UAAA;AACJ;;AAEE;EACE,UAAA;AACJ;;AAEE;EACE,UAAA;AACJ;AACA,wrBAAwrB","sourcesContent":[".property-card {\n    margin: 16px;\n  }\n  \n  table {\n    width: 100%;\n  }\n  \n  .mat-column-name {\n    width: 20%;\n  }\n  \n  .mat-column-type {\n    width: 20%;\n  }\n  \n  .mat-column-description {\n    width: 60%;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
